import { render, staticRenderFns } from "./NewsDetailOne.vue?vue&type=template&id=03461a5e&scoped=true&"
import script from "./NewsDetailOne.vue?vue&type=script&lang=js&"
export * from "./NewsDetailOne.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetailOne.vue?vue&type=style&index=0&id=03461a5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03461a5e",
  null
  
)

export default component.exports